import React from "react";
import { Container, Row, Col, Image } from "react-bootstrap";
import logo from "../assets/img/kuelly_logo_transparent.png";
import alto from "../assets/img/header_image_clean.jpg";

export default function KuellyHeroHeader({
  years = "X",
  imageSrc = alto,
  website = "www.kuelly.com.mx",
  email = "direccion@kuelly.com.mx",
  phone = "+52 442 798 99 37",
}) {
  const KU_GREEN = "#2f5d35";

  return (
    <section className="position-relative bg-white overflow-hidden">
      <style>{`
        :root { --ku-green: ${KU_GREEN}; }

        .hero-right{ background-position: right center; background-size: cover; }
        .hero-overlay{ position:absolute; inset:0;
          background:linear-gradient(90deg, rgba(0,0,0,.10), rgba(0,0,0,0) 60%); }
        .hero-bar{ background:var(--ku-green); color:#fff; z-index:2; }

        /* ====== Mobile-first (XS–SM): responsivo ====== */
        .ku-logo{
          /* móvil: que no se estire y escale fluido */
          width: auto;
          height: auto;
          max-width: min(90vw, 440px);
          display: block;
          margin: 0 auto;
        }
        .right-minh{ min-height: 40vh; } /* panel derecho visible en móvil */

        /* hero-band en móvil: casi todo el ancho y abajo */
        .hero-band {
          position: absolute;
          left: 2.5%;
          width: 95%;
          bottom: 0;
          z-index: 2;
        }

        /* ====== MD hacia arriba: conserva TU estilo original ====== */
        @media (min-width: 1150px){
          .ku-logo{
            max-width: 500px; /* tu valor original */
          }
          .right-minh{ min-height: unset; }
          .hero-band{
            left: 0;
            right: auto;
            width: 70%;
            bottom: 12rem;   /* igual que tu CSS */
          }
        }

        /* Desktop grande: tu ajuste fino */
        @media (min-width: 1200px){
          .hero-band{ width: 70%; bottom: 16vh; }
        }
      `}</style>

      <Container fluid className="p-0 min-vh-100 d-flex flex-column position-relative">
        <Row className="flex-grow-1 g-0">
          {/* IZQUIERDA */}
          <Col xs={12} md={8} lg={8} className="d-flex justify-content-center p-4 p-md-5">
            <div className="text-center mt-4 mt-md-5" style={{ maxWidth: 560, width: "100%" }}>
              <Image
                src={logo}
                alt="Kuelly logo"
                className="d-block mx-auto ku-logo"
                fluid
              />
            </div>
          </Col>

          {/* DERECHA */}
          <Col xs={12} md={4} lg={4} className="position-relative right-minh p-0">
            <div
              className="position-absolute top-0 end-0 bottom-0 start-0 hero-right"
              style={{ backgroundImage: `url(${imageSrc})` }}
            />
            <div className="hero-overlay" />
          </Col>
        </Row>

        {/* FRANJA INFERIOR */}
        <div className="hero-bar hero-band">
          <Container className="py-3 py-md-4">
            <Row className="align-items-end gy-2">
              <Col sm={12} md="auto" className="d-flex align-items-baseline">
                <div className="display-5 fw-bold me-3">{String(years).toUpperCase()}</div>
                <div className="fs-4 fw-medium">años Construyendo Sueños</div>
              </Col>
              <Col className="d-none d-md-block">
                <div className="border-top border-light opacity-50 mt-2" />
              </Col>
            </Row>

            <Row className="pt-3 gy-2">
              <Col sm={12} md={4}>
                <div className="fw-semibold opacity-90">Website</div>
                <div className="fw-bold"><span className="fas fa-globe me-2" /> {website}</div>
              </Col>
              <Col sm={12} md={4}>
                <div className="fw-semibold opacity-90">Email</div>
                <div className="fw-bold"><span className="fas fa-envelope me-2" /> {email}</div>
              </Col>
              <Col sm={12} md={4}>
                <div className="fw-semibold opacity-90">Contacto</div>
                <div className="fw-bold"><span className="fas fa-phone me-2" /> {phone}</div>
              </Col>
            </Row>
          </Container>
        </div>
      </Container>
    </section>
  );
}
